module.exports = __webpack_public_path__ + "img/25-grand-cherokee-nav.308b8006.png";